export const Theme = {
  colors: {
    background: "#ccc",
    light: "#eee",
    lightHover: "#ccc",
    lightActive: "#aaa",
    lightSecondary: "#ddd",
    lightBorder: "#ccc",
    dark: "#333",
    darkHover: "#222",
    darkActive: "#111",
    blue: "#143E72",
    primary: "#1ba148",
    primaryHover: "#0a9037",
    primaryActive: "#098026",
    secondary: "#c25c0e",
    secondaryHover: "#b14b0d",
    secondaryActive: "#a03a0c",
    red: "#b3211e",
    redHover: "#a2100d",
    redActive: "#91000c",
  },
};

export default Theme;
